export default __webpack_public_path__ + "static/media/uploadeImg.81541a3e.png";